import { ErrorNotification } from 'components/Notification';
import React, { FC, useEffect } from 'react';
import { translationKeys, useTranslation } from 'services/localization';
import { trackDisplayDeclineGmoiConsentBanner } from '../../../../services/userActionEvents';
import { ActionNotificationMessageProps } from '../../types';

const ErrorAcceptGmoi: FC<ActionNotificationMessageProps> = ({ onClose }) => {
  const { translate } = useTranslation();

  useEffect(() => {
    trackDisplayDeclineGmoiConsentBanner();
  }, []);

  return (
    <ErrorNotification title={translate(translationKeys.NOTIFICATION_ERROR_MESSAGE_TITLE)} onClose={onClose}>
      <p>{translate(translationKeys.GMOI_REQUEST_ERROR_MESSAGE)}</p>
    </ErrorNotification>
  );
};

export default ErrorAcceptGmoi;
